export default (initialState: any) => {
  const canSeeRoot = initialState?.user?.admin === 1;
  return {
    root: canSeeRoot,
    admin: !canSeeRoot,
  };
};
